import styled from 'styled-components';
import ButtonIcon from 'components/ButtonIcon';
import Input from 'components/Input';
import {
    DIVIDER, GREY_100, GREY_300, RED_500,
} from '../../constants';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-self: stretch;
    gap: 0.625rem;
`;

export const HolidayRow = styled.div`
    display: flex;
    align-items: center;
    align-self: stretch;
    gap: 0.5rem;
`;

export const EmptyLabel = styled.div`
    display: flex;
    flex: 1;
    align-items: center;
    height: 2.875rem;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.3125rem;
    color: ${GREY_300};
`;

export const NameInput = styled(Input)<{ $duplicated?: boolean }>`
    flex: 1;
    min-width: 0;

    input {
        height: 2.875rem;
        border-radius: 0.375rem;
        border: 1px solid ${(props) => (props.$duplicated ? RED_500 : DIVIDER)};
        color: ${(props) => (props.$duplicated ? RED_500 : 'inherit')};

        ::placeholder {
            font-weight: 300 !important;
            color: ${(props) => (props.$duplicated ? RED_500 : 'inherit')};
        }
    }
`;

export const DateControl = styled.div`
    position: relative;
    flex: none;
`;

export const DateButton = styled.button<{ $duplicated?: boolean }>`
    flex: none;
    width: 7.5rem;
    height: 2.875rem;
    padding-right: ${(props) => (props.$duplicated ? '1.75rem' : '0.75rem')};
    border: 1px solid ${(props) => (props.$duplicated ? RED_500 : 'transparent')};
    border-radius: 0.375rem;
    background: #F8F8F8;
    color: ${(props) => (props.$duplicated ? RED_500 : 'inherit')};
    font-size: 1rem;
    text-align: center;
    cursor: pointer;

    &:hover,
    &:focus {
        background: ${GREY_100};
        outline: none;
    }
`;

export const DuplicateInfo = styled(ButtonIcon)`
    position: absolute;
    top: 50%;
    right: 0.5rem;
    width: 1.25rem;
    height: 1.25rem;
    min-width: 1.25rem;
    padding: 0;
    border: none;
    background: transparent;
    color: ${RED_500};
    transform: translateY(-50%);

    svg {
        width: 1rem !important;
        height: 1rem !important;
        font-size: 1rem !important;
        color: ${RED_500};
    }

    svg circle,
    svg path {
        stroke: ${RED_500} !important;
    }
`;

export const StyledButtonIcon = styled(ButtonIcon)`
    flex: none;
`;

export const HiddenFileInput = styled.input`
    display: none;
`;
